export default async function getAndroidFileBlob(fileUri) {
  let androidFile = await this.getAndroidFile(fileUri);

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = (ev) => {
      if (ev.target.error) {
        return reject(ev.target.error);
      }
      let blob = new Blob([new Uint8Array(reader.result)], {type: androidFile.type});
      blob.lastModifiedDate = new Date();
      blob.name = androidFile.name;
      return resolve(blob);
    };
    reader.readAsArrayBuffer(androidFile);
  });
}
